import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { BannerStandImagesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { ListStatus, EditableStatus } from '@/store/types';

const state: BannerStandImagesState = {
  list: [],
  listStatus: ListStatus.Loading,
  listPagination: {
    currentPage: 1,
    lastPage: 1,
    total: 0,
  },
  editable: null,
  initialEditable: null,
  editableStatus: EditableStatus.Loading,
  products: [],
  usedProducts: [],
  existingLanguages: [],
};

const bannerStandImages: Module<BannerStandImagesState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default bannerStandImages;

